<template>
  <div>
    <!-- reviews/downloads -->
    <div v-if="deal.is_free" class="text-left text-md-center">
      <font-awesome-icon
        :icon="['far', 'arrow-alt-circle-down']"
        class="icon"
      />
      <strong>Total Downloads: {{ deal.freebie_downloads_total.toLocaleString('en-US') }}</strong>
    </div>
    <div v-else-if="reviewCount" class="d-flex align-items-center">
      <DTacoRating
        :value="reviewAvg"
        class="mr-1 mr-lg-2"
        size="sm"
        read-only
      />
      <div class="d-inline-flex flex-shrink-0">
        <strong class="font-weight-medium review-text">
          <NuxtLink :to="`${deal.get_absolute_url}#reviews`">
            {{ reviewCount }} {{ reviewCount > 1 ? 'Reviews' : 'Review' }}
          </NuxtLink>
        </strong>
      </div>
    </div>
    <div v-else>
      <span class="no-taco-rating">
        No reviews yet,
      </span>
      <NuxtLink :to="`${deal.get_absolute_url}#reviews`">
        be the first!
      </NuxtLink>
    </div>
  </div>
</template>
<script>
import { DTacoRating } from '@appsumo/dorado-taco-rating';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    DTacoRating,
    FontAwesomeIcon,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    reviewAvg() {
      return this.deal?.deal_review?.average_rating || 0;
    },

    reviewCount() {
      return this.deal?.deal_review?.review_count || 0;
    },
  },
};
</script>
